import clsx from "clsx";
import { MainCtaButton } from "../components/MainCtaButton";
import { LandingCustomers } from "../LandingTemplate/components/LandingCustomers";

import NoCodeDeployment from "../../assets/svg/DataApi/NoCodeDeployment.svg";
import RestfulDeployment from "../../assets/svg/DataApi/RestfulDeployment.svg";
import SimpleDeployment from "../../assets/svg/DataApi/SimpleDeployment.svg";
import FrictionlessDeployment from "../../assets/svg/DataApi/FrictionlessDeployment.svg";
import CentralizeManagement from "../../assets/svg/DataApi/CentralizeManagement.svg";
import DeploymentManagement from "../../assets/svg/DataApi/DeploymentManagement.svg";
import LifecycleManagement from "../../assets/svg/DataApi/LifecycleManagement.svg";

import Clearco from "../assets/logos/Clearco.svg";
import Openly from "../assets/logos/Openly.svg";
import Farmers from "../assets/logos/Farmers.svg";
import StandardChartered from "../assets/logos/StandardChartered.svg";
import Anz from "../assets/logos/Anz.svg";

import Featured1 from "../HomePage/assets/icons/Featured1.svg";
import ExternalDataSolutions from "../HomePage/assets/External_Data_Solutions.svg";

export const DataApi = ({ keyword }) => {
  const data = {
    "centralize-management": {
      heroData: {
        title: "Centrally Manage All Third Party Data",
        subtitle:
          "Centrally manage all your third party data APIs with the Demyst platform and reduce security risks, improve performance and unlock value at scale within your organization.",
        image: CentralizeManagement.src,
        image_alt:
          "diagram demonstrating a Demyst third party data central management capabilities",
      },
    },
    "deployment-management": {
      heroData: {
        title: "One Platform To Manage API Deployments",
        subtitle:
          "Centrally manage all your third party data API deployments with the Demyst platform to reduce security risks, improve performance and unlock value at scale within your organization.",
        image: DeploymentManagement.src,
        image_alt:
          "diagram demonstrating a Demyst third party data deployment management capabilities",
      },
    },
    "frictionless-deployment": {
      heroData: {
        title: "Frictionless Deployment of Data APIs",
        subtitle:
          "Easily deploy external data APIs to power core application within your organization. Create an account and deploy your first API in minutes within our platform.",
        image: FrictionlessDeployment.src,
        image_alt: "diagram symbolizing a Demyst API frictionless deployment",
      },
    },

    "lifecycle-management": {
      heroData: {
        title: "End-to-end Data API Lifecycle Management",
        subtitle:
          "Easily build, consume and manage HTTP APIs that provide the external data you need to power core applications.",
        image: LifecycleManagement.src,
        image_alt:
          "diagram demonstrating a Demyst third party data lifecycle management capabilities",
      },
    },
    "no-code-deployment": {
      heroData: {
        title: "No Code Deployment of Data APIs",
        subtitle:
          "Deploy third party data in minutes with our no-code deployment platform. Why spend weeks building third party data API when you can unlock the same potential in minutes? See Demyst in action for free today.",
        image: NoCodeDeployment.src,
        image_alt: "diagram symbolizing a Demyst API no code deployment",
      },

      valueSectionData: {
        title: "The power of no code data deployment",
        items: [
          {
            heading: "Empower your business users",
            paragraph:
              "No code approach to third party data allow your business users to quickly demonstrate lift and identify what data will deliver value to your organization.",
          },
          {
            heading: "Free your technical team",
            paragraph:
              "Allow your technical team to focus on building applications and functions that truly matter to your business. Our platform takes care of setting up the foundations to allow your team to build great products.",
          },
          {
            heading: "Deliver value at scale",
            paragraph:
              "No code, no bottleneck. Truly democratize third party data within your organization and super charge innovation within every team.",
          },
        ],
      },
    },
    "restful-deployment": {
      heroData: {
        title: "Deploying HTTP APIs from the Demyst Platform",
        subtitle:
          "Easily deploy HTTPs APIs that provide the external data and customised logic you need to power core applications, data workflows or pull directly into your CRM.",
        image: RestfulDeployment.src,
        image_alt: "diagram symbolizing a Demyst API restful deployment",
      },
    },
    "simple-deployment": {
      heroData: {
        title: "Deploy a Data API With Ease",
        subtitle:
          "Access third party data in minutes with a streamlined data deployment platform. In just a few minutes, you can deploy a data API to the data source of your choosing.",
        image: SimpleDeployment.src,
        image_alt: "diagram demonstrating a Demyst API simple deployment workflow",
      },
    },
    landingCustomersData: {
      fields: {
        subheadline: `Join the customers already unlocking the power of third party data with Demyst:`,
        logos: [
          {
            image: Farmers.src,
            image_alt: "Farmers Insurance",
          },
          {
            image: Anz.src,
            image_alt: "ANZ",
          },
          {
            image: StandardChartered.src,
            image_alt: "Standard Chartered",
          },
          {
            image: Openly.src,
            image_alt: "Openly",
          },
          {
            image: Clearco.src,
            image_alt: "Clearco (formerly Clearbank)",
          },
        ],
      },
    },
  };

  return (
    <>
      <section className={clsx("LandingHero-background", "LandingHero-background-purple")}>
        <div className={clsx("LandingHero", "LandingHero-align-center")} id="hero">
          <section className="section-layout">
            <h1 className="LandingHero-title">{data[keyword]?.heroData?.title}</h1>
            <p className="LandingHero-subtitle">{data[keyword]?.heroData?.subtitle}</p>
            <div className="LandingCtas">
              <MainCtaButton />
            </div>
            <img
              className={clsx(
                "LandingHero-image",
                "noRadius",
                keyword === "centralize-management" && "centralizeManagement",
              )}
              src={data[keyword]?.heroData?.image}
              alt={data[keyword]?.heroData?.image_alt}
              loading="eager"
            />
          </section>
        </div>
      </section>
      {data[keyword]?.valueSectionData && (
        <div
          className={clsx(
            "LandingMainContent",
            "LandingMainContent-background-gray-2",
            "LandingMainContent-align-left",
            "LandingMainContent-text_image",
            "Campaign",
          )}
          id="api-deployment"
        >
          <section className="section-layout">
            <div
              className={clsx(
                "LandingTextImageContent-col",
                "LandingTextImageContent-col-text",
                `LandingTextImageContent-col-text-position-left`,
              )}
            >
              <h2>{data[keyword]?.valueSectionData?.title}</h2>
              <ul className="LandingTextImageContent-customUl2">
                {data[keyword]?.valueSectionData?.items?.map(item => (
                  <li key={item?.heading}>
                    <img src={Featured1.src} alt="" width="48" height="48" loading="lazy" />
                    <div>
                      <h3>{item?.heading}</h3>
                      <p>{item?.paragraph}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="LandingTextImageContent-col">
              <img src={ExternalDataSolutions.src} alt="" loading="lazy" width="588" height="506" />
            </div>
          </section>
        </div>
      )}
      <div
        className={clsx(
          "LandingMainContent",
          "LandingMainContent-background-blue",
          "LandingMainContent-align-center",
          "LandingMainContent-customers",
          "Campaign",
        )}
        id="customers"
      >
        <LandingCustomers data={data?.landingCustomersData} />
      </div>
    </>
  );
};
